import { render, staticRenderFns } from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=template&id=1d937f69&scoped=true"
import script from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=script&lang=js"
export * from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=script&lang=js"
import style0 from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=style&index=0&id=1d937f69&prod&lang=scss"
import style1 from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=style&index=1&id=1d937f69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d937f69",
  null
  
)

export default component.exports